import { QueryFunctionContext } from '@tanstack/react-query'
import { KeywordsAutoSuggestService } from 'shared/services/KeywordsAutoSuggestService'
import type { AutoSuggestResponse, DefaultAutoSuggestQuery } from 'app/features/Gallery/queries/interface'

const DEFAULT_SUGGESTIONS_LIMIT = 5

export const querySearchSuggestions = (context: QueryFunctionContext<DefaultAutoSuggestQuery>): Promise<AutoSuggestResponse | null> => {
  const { queryKey } = context
  const [_, { galleryName, keyword, locale, limit, searchBackend }] = queryKey

  return KeywordsAutoSuggestService.getSuggestions({
    galleryName,
    keyword,
    locale,
    limit: limit || DEFAULT_SUGGESTIONS_LIMIT,
    searchBackend,
  })
}
